export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const REACT_APP_GOOGLE_MAPS_API_KEY = GOOGLE_MAPS_API_KEY;
